/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_History_Empty1Inputs */

const vi_cmstools_history_empty1 = /** @type {(inputs: Cmstools_History_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa đăng lần nào.`)
};

/**

* @param {Cmstools_History_Empty1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_history_empty1 = /** @type {((inputs?: Cmstools_History_Empty1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_History_Empty1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_history_empty1(inputs)
});
export { cmstools_history_empty1 as "cmsTools_history_empty" }